<template>
  <div id="settingPop">
    <div class="setting-box">
      <div class="close-btn" @click="closePop">
        <img src="../../assets/images/cartoon-kid/close.png" />
      </div>
      <div class="btn-box">
        <div class="btn-box_num1 btn-box_num" @click="pageJump(1)">
          <img src="../../assets/images/cartoon-kid/record.png" />
          <p>我的档案</p>
        </div>
        <div class="btn-box_num2 btn-box_num" @click="pageJump(2)">
          <img src="../../assets/images/cartoon-kid/collect.png" />
          <p>我的收藏</p>
        </div>
        <div class="btn-box_num3 btn-box_num" @click="pageJump(3)">
          <img src="../../assets/images/cartoon-kid/order.png" />
          <p>我的订单</p>
        </div>
      </div>
      <div class="btn-box1 btn-box">
        <div class="btn-box_num4 btn-box_num" @click="pageJump(4)">
          <img src="../../assets/images/cartoon-kid/healthassess.png" />
          <p>筛查及考核</p>
        </div>
        <div class="btn-box_num5 btn-box_num" @click="pageJump(5)">
          <img src="../../assets/images/cartoon-kid/video.png" />
          <p>迪夫学院</p>
        </div>
        <div class="btn-box_num6 btn-box_num" @click="pageJump(6)">
          <img src="../../assets/images/cartoon-kid/setting.png" />
          <p>设置</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { cartoonKidEventStore } from "@/common/cartoon-kid-event-store";
import { decryptBy } from "@/assets/js/encryption";
import Cookies from "js-cookie";
import { _getUser } from "../../api/login";
export default {
  name: "setting-pop",
  data() {
    return {};
  },
  created() {},
  methods: {
    // 关闭弹窗
    closePop() {
      this.$emit("closePop");
    },
    pageJump(val) {
      // 完成跳转关闭弹窗，小人回到侧边
      this.$emit("closePop", "jumpAfter");
      switch (val) {
        case 1:
          this.jumpBefore("/myInformation");
          break;
        case 2:
          this.jumpBefore("course", 1);
          sessionStorage.setItem("tabValue", 1);
          localStorage.setItem("colu", "收藏");
          break;
        case 3:
          this.jumpBefore("/myOrder");
          break;
        case 4:
          this.jumpBefore("/testCenter");
          break;
        case 5:
          this.jumpBefore("/course");
          break;
        case 6:
          this.jumpBefore("/setting");
          break;
      }
    },
    // 跳转页面前，提示用户保存当前页面数据
    jumpBefore(url, query) {
      let routeNextComplete = () => {
        cartoonKidEventStore.resetJumpAction();
        cartoonKidEventStore.restNext();
      };
      let closePop = () => {
        this.closePop();
      };
      let next = () => {
        if (query) {
          this.$router
            .push({
              name: url,
              params: {
                val: 1,
              },
            })
            .finally(routeNextComplete);
          closePop();
          // 如果在首页中进入我的收藏
          this.$bus.$emit("toConcerned", 0);
        } else {
          closePop();
          if (url != "/myInformation") {
            this.$router.push(`${url}`).finally(routeNextComplete);
          } else {
            let token = Cookies.get("token");
            _getUser({
              authentication: token,
              // origin:'C'
            }).then((res) => {
              if (res && res.code == 200) {
                let isParent = res.data.userType === "PARENT" ? 1 : 2;
                this.$router
                  .push({
                    path: url,
                    query: {
                      isParent,
                    },
                  })
                  .finally(routeNextComplete);
              }
            });
          }
        }
      };
      if (cartoonKidEventStore.jumpAction) {
        cartoonKidEventStore.jumpAction(next);
      } else {
        next();
      }
    },
  },
};
</script>
<style scoped lang="scss">
#settingPop {
  position: fixed;
  top: 0;
  right: 0;
  z-index: 99999999;
  width: 375px;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  .setting-box {
    position: relative;
    margin: 0 auto;
    width: 295px;
    height: 278px;
    background: #ffffff;
    border-radius: 20px;
    background-image: url("../../assets/images/cartoon-kid/bac.png");
    background-repeat: no-repeat;
    background-size: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    .close-btn {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 22px;
    }
    .btn-box {
      display: flex;
      padding-left: 10px;
      .btn-box_num {
        width: 78px;
        height: 100px;
        background: linear-gradient(
          181deg,
          rgba(183, 255, 155, 0.1) 0%,
          rgba(93, 205, 89, 0.12) 100%
        );
        border-radius: 8px;
        text-align: center;
        margin-top: 40px;
        margin-left: 10px;
        img {
          width: 50px;
          height: 50px;
          margin-top: 14px;
        }
        p {
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #2e4344;
          margin-top: 8px;
        }
      }
      .btn-box_num2 {
        background: linear-gradient(
          181deg,
          rgba(255, 220, 227, 0.1) 0%,
          rgba(250, 147, 181, 0.12) 100%
        );
      }
      .btn-box_num3 {
        background: linear-gradient(
          181deg,
          rgba(233, 183, 255, 0.11) 0%,
          rgba(197, 165, 255, 0.12) 100%
        );
      }
      .btn-box_num4 {
        background: linear-gradient(
          181deg,
          rgba(255, 250, 158, 0.1) 0%,
          rgba(255, 196, 135, 0.12) 100%
        );
      }
      .btn-box_num5 {
        background: linear-gradient(
          181deg,
          rgba(159, 228, 255, 0.1) 0%,
          rgba(26, 187, 254, 0.12) 100%
        );
      }
      .btn-box_num6 {
        background: linear-gradient(
          181deg,
          rgba(154, 255, 226, 0.1) 0%,
          rgba(24, 219, 220, 0.12) 100%
        );
      }
    }
    .btn-box1 {
      .btn-box_num {
        margin-top: 10px;
      }
    }
  }
}
</style>
